import { render, staticRenderFns } from "./LicitacaoAtualizacaoEdital.vue?vue&type=template&id=793fa0f6"
import script from "./LicitacaoAtualizacaoEdital.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacaoEdital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports